// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2G1te","title":"FrontImage_title__1jUXf"};